<template>
  <div class="required-text"><span>*</span> {{ $t("generic.required_field") }}</div>
</template>

<script>
  export default {
    name: "RequiredFieldText",
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions.scss";

  .required-text {
    margin-top: 16px;
    @include text-caption();
    color: get-color("subtitle");

    span {
      color: get-color("primary");
    }
  }
</style>
